<template>
  <div class="chart-card">
    <div v-if="spec && spec.title" class="chart-title">{{ spec.title }}</div>

    <BarChart v-if="spec && spec.type === 'bar'" :spec="spec" />
    <PieChart
      v-else-if="spec && (spec.type === 'pie' || spec.type === 'donut')"
      :spec="spec"
    />
    <ComparisonTable
      v-else-if="spec && spec.type === 'comparison'"
      :spec="spec"
      :document-index="documentIndex"
      @ref-click="(refData, event) => $emit('ref-click', refData, event)"
    />

    <div v-else class="chart-error">
      <v-icon size="14" class="mr-1">mdi-information</v-icon>
      Couldn't render chart — the spec was missing or malformed.
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';
import BarChart from './BarChart.vue';
import PieChart from './PieChart.vue';
import ComparisonTable from './ComparisonTable.vue';

export default defineComponent({
  name: 'ChartView',
  components: { BarChart, PieChart, ComparisonTable },
  props: {
    spec: { type: Object, default: null },
    documentIndex: { type: Map, default: null },
  },
  emits: ['ref-click'],
});
</script>

<style scoped>
.chart-card {
  margin: 12px 0;
  padding: 12px;
  border-radius: 8px;
  border: 1px solid rgb(229 231 235);
  background: white;
}
.chart-title {
  margin-bottom: 8px;
  font-size: 14px;
  font-weight: 600;
  color: rgb(31 41 55);
}
.chart-error {
  font-size: 12px;
  color: rgb(107 114 128);
  font-style: italic;
  display: flex;
  align-items: center;
}
</style>
